import alt from 'alt'
import { createStore } from 'alt-utils/lib/decorators'
import { PlusActions } from 'actions'

@createStore(alt)
export default class PlusStore {
  constructor() {
    this.state = {
      installed:    false,
      isInstalling: false,
      isUpgrade:    false,
      failed:       false,
      status:       {}
    }

    this.bindActions(PlusActions)
  }

  static displayName = 'PlusStore'

  setPlus({ status, installed }) {
    this.setState({ status, installed })
  }

  setInstalling(status) {
    this.setState({ isInstalling: status })
  }

  setFailed(status) {
    this.setState({ failed: status })
  }

  setIsUpgrade(isUpgrade) {
    this.setState({ isUpgrade })
  }
}



// WEBPACK FOOTER //
// ./app/stores/PlusStore.js